var $ = require('jquery'),
	gc = require('./gc'),
	keycode = require('keycode'),
	$w = $(window),
	$b = $('body');

gc.where('body', function($el){
	$b = $el;
});



var Mode = module.exports = {
	set: function( mode )
	{
		$b.attr('data-mode', mode);
	},
	get: function()
	{
		return $b.attr('data-mode');
	},
	clear: function()
	{
		$b.removeAttr('data-mode');
		$('[data-set-mode]').removeAttr('aria-pressed');
	},
	toggle: function( mode )
	{
		$b.attr('data-mode') == mode ? $b.removeAttr('data-mode') : $b.attr('data-mode', mode);
	}
};

document.addEventListener('keyup', function(e) {

	if(keycode(e) == 'esc')
		$b.removeAttr('data-mode');		
});

gc.when('[data-set-mode]', function($btn){
	var mode = $btn.data('set-mode');
	$btn.click(function(e){
		Mode.toggle( mode );
		$btn.attr('aria-pressed', $btn.attr('aria-pressed') !== 'true');
	});
	$btn.keypress(function(e){
		if(['space', 'return'].indexOf(keycode(e)) > -1){
			e.preventDefault();
			$btn.click();
		}
	});
});


//////////////////
// WEBPACK FOOTER
// ./themes/gc/js/mode.js
// module id = 3
// module chunks = 0